module.exports = __webpack_public_path__ + "media/images/draggable-08b4157a.svg";